import React from 'react'
import Logo from '../../assets/logo white.svg'
import "./Topbar.scss"
import { Link } from 'react-router-dom'

function Topbar({bgColor}) {
 
  return (
    <div className='topbar-container' style={ {backgroundColor: bgColor ? "#1f5da2":""}}>
      <Link to='/' >
      <img src={Logo} alt="logo" className='topbar_logo' />
      </Link>
      <div className="menu">
        <ul>
          <Link to='/cities' ><li>Города</li></Link>
          <Link to='/tours'><li>Туры</li></Link>
          <Link to='/hotels'><li>Отели</li></Link>
          <Link to='/service'><li>Услуги</li></Link>
            
            
            
            
        </ul>
      </div>
    </div>
  )
}

export default Topbar
